export * from '@fhs/routing/src/routes/order-confirmation/_layout';
export { default } from '@fhs/routing/src/routes/order-confirmation/_layout';
